<template>
  <div class="user-management">
    <div class="page-card">
      <div class="user-type-segment-wrap">
        <div
          class="user-type-segment"
          role="tablist"
          aria-label="用户类型"
        >
          <button
            type="button"
            role="tab"
            class="segment-item"
            :class="{ active: activeUserType === 'personal' }"
            :aria-selected="activeUserType === 'personal'"
            @click="setUserType('personal')"
          >
            个人用户
          </button>
          <button
            type="button"
            role="tab"
            class="segment-item"
            :class="{ active: activeUserType === 'enterprise' }"
            :aria-selected="activeUserType === 'enterprise'"
            @click="setUserType('enterprise')"
          >
            企业用户
          </button>
        </div>
      </div>

      <div class="search-section">
        <el-form
          :model="searchForm"
          class="search-form"
          label-position="left"
          label-width="84px"
        >
          <div class="search-row">
            <template v-if="activeUserType === 'personal'">
              <el-form-item
                label="真实姓名"
                class="search-field"
              >
                <el-input
                  v-model="searchForm.userRealName"
                  placeholder="请输入"
                  clearable
                  class="search-input"
                  @keyup.enter="handleSearch"
                />
              </el-form-item>
              <el-form-item
                label="手机号码"
                class="search-field"
              >
                <el-input
                  v-model="searchForm.userPhone"
                  placeholder="请输入"
                  clearable
                  class="search-input"
                  @keyup.enter="handleSearch"
                />
              </el-form-item>
              <el-form-item
                label="邮箱"
                class="search-field"
              >
                <el-input
                  v-model="searchForm.userEmail"
                  placeholder="请输入"
                  clearable
                  class="search-input"
                  @keyup.enter="handleSearch"
                />
              </el-form-item>
              <el-form-item
                label="证件号码"
                class="search-field"
              >
                <el-input
                  v-model="searchForm.userIdCardNo"
                  placeholder="请输入"
                  clearable
                  class="search-input"
                  @keyup.enter="handleSearch"
                />
              </el-form-item>
            </template>
            <template v-else>
              <el-form-item
                label="企业名称"
                class="search-field"
              >
                <el-input
                  v-model="searchForm.entName"
                  placeholder="请输入"
                  clearable
                  class="search-input"
                  @keyup.enter="handleSearch"
                />
              </el-form-item>
              <el-form-item
                label="主体识别码"
                class="search-field"
              >
                <el-input
                  v-model="searchForm.creditCode"
                  placeholder="请输入"
                  clearable
                  class="search-input"
                  @keyup.enter="handleSearch"
                />
              </el-form-item>
              <el-form-item
                label="联系人电话"
                class="search-field"
              >
                <el-input
                  v-model="searchForm.linkmanPhone"
                  placeholder="请输入"
                  clearable
                  class="search-input"
                  @keyup.enter="handleSearch"
                />
              </el-form-item>
            </template>
            <el-form-item
              label="代理状态"
              class="search-field"
            >
              <el-select
                v-model="searchForm.authStatus"
                placeholder="全部"
                clearable
                class="search-select"
              >
                <el-option
                  label="未授权"
                  value="0"
                />
                <el-option
                  label="已授权"
                  value="1"
                />
              </el-select>
            </el-form-item>

            <div class="search-actions">
              <el-button
                type="primary"
                size="default"
                class="btn-query"
                @click="handleSearch"
              >
                <el-icon><Search /></el-icon>
                查询
              </el-button>
              <el-button
                size="default"
                class="btn-reset"
                @click="handleReset"
              >
                <el-icon><Refresh /></el-icon>
                重置
              </el-button>
            </div>
          </div>
          <div class="search-row search-row--second" />
        </el-form>
      </div>

      <div class="action-bar">
        <el-button
          type="primary"
          @click="handleAdd"
        >
          {{ activeUserType === 'personal' ? '邀请个人用户' : '邀请企业用户' }}
        </el-button>
      </div>

      <div class="table-wrap">
        <el-table
          v-loading="loading"
          :data="userList"
          style="width: 100%"
          stripe
          border
          class="user-table"
          height="560"
        >
        <template #empty>
          <EmptyPlaceholder v-if="!loading" />
        </template>
        <el-table-column
          type="index"
          label="序号"
          width="60"
          align="center"
        />
        <template v-if="activeUserType === 'personal'">
          <el-table-column
            prop="userNickName"
            label="昵称"
            align="center"
            min-width="120"
          />
          <el-table-column
            prop="userRealName"
            label="真实姓名"
            align="center"
            min-width="100"
          />
          <el-table-column
            prop="userIdCardNo"
            label="证件号码"
            align="center"
            min-width="180"
          />
          <el-table-column
            prop="userPhone"
            label="手机号码"
            align="center"
            min-width="130"
          />
          <el-table-column
            prop="userEmail"
            label="邮箱"
            align="center"
            min-width="158"
          />
        </template>
        <template v-else>
          <el-table-column
            prop="entName"
            label="企业名称"
            align="center"
            min-width="200"
          />
          <el-table-column
            prop="creditCode"
            label="主体识别码"
            align="center"
            min-width="180"
          />
          <el-table-column
            prop="linkmanName"
            label="联系人"
            align="center"
            min-width="120"
          />
          <el-table-column
            prop="linkmanPhone"
            label="联系人电话"
            align="center"
            min-width="130"
          />
          <el-table-column
            prop="linkmanEmail"
            label="联系人邮箱"
            align="center"
            min-width="180"
          />
        </template>
        <el-table-column
          prop="authStatus"
          label="授权代理"
          align="center"
          width="118"
        >
          <template #default="{ row }">
            <el-tag
              :type="getRelationStatusType(row.authStatus)"
              size="small"
            >
              {{ getRelationStatusText(row.authStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="updateTime"
          label="最后更新时间"
          align="center"
          min-width="158"
        />
        <el-table-column
          v-if="$auth.isChannel() || $auth.isOrganization()"
          label="操作"
          align="center"
          width="220"
          fixed="right"
        >
          <template #default="{ row }">
            <el-button
              v-if="row.authStatus === '0' && $auth.isChannel()"
              type="primary"
              plain
              size="small"
              @click="handleInviteProxy(row)"
            >
              邀请代理
            </el-button>
            <el-button
              v-if="row.authStatus === '1' && row.agentEntType === EnterpriseType.CHANNEL.value"
              type="warning"
              plain
              size="small"
              @click="handleCancelAgency(row)"
            >
              取消授权
            </el-button>
            <el-button
              type="danger"
              plain
              size="small"
              @click="handleDelete(row)"
            >
              移除
            </el-button>
          </template>
        </el-table-column>
        </el-table>
      </div>

      <div class="pagination-section">
        <el-pagination
          v-model:current-page="pagination.pageNum"
          v-model:page-size="pagination.pageSize"
          :total="pagination.total"
          :page-sizes="[10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
      </div>
    </div>

    <InvitePersonalUserDialog
      v-model="invitePersonalDialogVisible"
      :title="'邀请个人用户'"
      :require-verified="true"
      confirm-button-text="发起邀请"
      @confirm="handleConfirmInvitePersonal"
    />
    <InviteEnterpriseUserDialog
      v-model="inviteEnterpriseDialogVisible"
      :title="'邀请企业用户'"
      :require-verified="true"
      confirm-button-text="发起邀请"
      @confirm="handleConfirmInviteEnterprise"
    />
  </div>
</template>

<script>
import { ElMessage } from 'element-plus'
import { Search, Refresh } from '@element-plus/icons-vue'
import { showEnhancedConfirmDialog } from '@/utils/messageUtils'
import { getUserList, removeClient, cancelCustomerAgency } from '@/api/workbench'
import { sendApproval } from '@/api/approval'
import InvitePersonalUserDialog from '@/components/InviteDialog/InvitePersonalDialog.vue'
import InviteEnterpriseUserDialog from '@/components/InviteDialog/InviteEnterpriseDialog.vue'
import EmptyPlaceholder from '@/components/EmptyPlaceholder.vue'
import { BusinessTypeEnum } from '@/enums/BusinessTypeEnum'
import { EnterpriseType } from '@/enums/enterpriseType'

export default {
  name: 'UserManagement',
  components: {
    Search,
    Refresh,
    InvitePersonalUserDialog,
    InviteEnterpriseUserDialog,
    EmptyPlaceholder
  },
  data() {
    return {
      EnterpriseType, // 暴露给模板使用，用于判断 agentEntType 是否为渠道
      activeUserType: 'personal', // 当前选中的用户类型：personal-个人用户, enterprise-企业用户
      loading: false,
      searchForm: {
        // 个人用户搜索字段
        userNickName: '',
        userRealName: '',
        userPhone: '',
        userEmail: '',
        userIdCardNo: '',
        // 企业用户搜索字段
        entName: '',
        creditCode: '',
        linkmanPhone: '',
        // 公共搜索字段
        authStatus: ''
      },
      userList: [],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      // 邀请个人用户弹窗显示状态
      invitePersonalDialogVisible: false,
      // 邀请企业用户弹窗显示状态
      inviteEnterpriseDialogVisible: false
    }
  },
  mounted() {
    this.loadUserList()
  },
  methods: {
    /**
     * 切换个人/企业用户类型
     */
    setUserType(type) {
      if (this.activeUserType === type) return
      this.activeUserType = type
      this.handleTabChange()
    },
    /**
     * 标签页切换处理
     */
    handleTabChange() {
      // 切换标签时重置分页并重新加载数据
      this.pagination.pageNum = 1
      this.loadUserList()
    },
    /**
     * 加载用户列表
     */
    async loadUserList() {
      this.loading = true
      try {
        // 构建查询参数
        const params = {
          queryType: this.activeUserType, // personal-个人用户, enterprise-企业用户
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize
        }
        
        // 根据用户类型添加搜索条件
        if (this.activeUserType === 'personal') {
          // 个人用户搜索条件 - 直接使用 searchForm 中的字段名
          if (this.searchForm.userNickName) {
            params.userNickName = this.searchForm.userNickName
          }
          if (this.searchForm.userRealName) {
            params.userRealName = this.searchForm.userRealName
          }
          if (this.searchForm.userPhone) {
            params.userPhone = this.searchForm.userPhone
          }
          if (this.searchForm.userEmail) {
            params.userEmail = this.searchForm.userEmail
          }
          if (this.searchForm.userIdCardNo) {
            params.userIdCardNo = this.searchForm.userIdCardNo
          }
        } else {
          if (this.searchForm.entName) {
            params.entName = this.searchForm.entName
          }
          if (this.searchForm.creditCode) {
            params.creditCode = this.searchForm.creditCode
          }
          if (this.searchForm.linkmanPhone) {
            params.linkmanPhone = this.searchForm.linkmanPhone
          }
        }
        
        // 公共搜索条件
        if (this.searchForm.authStatus !== undefined && this.searchForm.authStatus !== '') {
          params.authStatus = this.searchForm.authStatus
        }
        
        // 调用API获取用户列表
        const response = await getUserList(params)
        
        if (response && response.code === 200) {
          // 处理返回的数据
          this.userList = response.rows || []
          this.pagination.total = response.total || 0
        } else {
          this.userList = []
          this.pagination.total = 0
        }
      } catch (error) {
        console.error('加载用户列表失败:', error)
        ElMessage.error(error.message || '加载用户列表失败')
        this.userList = []
        this.pagination.total = 0
      } finally {
        this.loading = false
      }
    },
    /**
     * 搜索
     */
    handleSearch() {
      this.pagination.pageNum = 1
      this.loadUserList()
    },
    /**
     * 重置搜索条件
     */
    handleReset() {
      this.searchForm = {
        userNickName: '',
        userRealName: '',
        userPhone: '',
        userEmail: '',
        userIdCardNo: '',
        entName: '',
        creditCode: '',
        linkmanPhone: '',
        authStatus: ''
      }
      this.handleSearch()
    },
    /**
     * 新增用户
     */
    handleAdd() {
      if (this.activeUserType === 'personal') {
        this.invitePersonalDialogVisible = true
      } else {
        this.inviteEnterpriseDialogVisible = true
      }
    },
    /**
     * 确认邀请个人用户
     */
    async handleConfirmInvitePersonal({ queryResult }) {
      await this.handleConfirmInvite({ approverId: queryResult.userId, userType: 'personal' })
    },
    /**
     * 确认邀请企业用户
     */
    async handleConfirmInviteEnterprise({ queryResult }) {
      await this.handleConfirmInvite({ approverId: queryResult.entId, userType: 'enterprise' })
    },
    
    /**
     * 确认邀请用户（个人或企业）
     * @param {Object} params - 邀请参数
     * @param {Object} params.approverId - 邀请人id
     * @param {string} params.userType - 用户类型：'personal' | 'enterprise'
     */
     async handleConfirmInvite({ approverId, userType }) {
      try {
        const mainBody = this.$auth.getMainBody()
        // 获取当主体id
        const applicantId = mainBody?.mainBodyId

        // 根据主体类型确定业务类型：渠道邀请用户加入 或 机构邀请代理授权
        const businessType = this.$auth.isChannel()
          ? BusinessTypeEnum.INVITE_JOIN_CHANNEL.code
          : BusinessTypeEnum.ORGANIZATION_INVITE_AGENCY_AUTH.code

        // 构建添加代理关系的数据
        const relationData = {
          applicantParentId: mainBody?.salesmanOwnershipEnterpriseId, // 发起主体父ID
          applicantId: applicantId, // 发起主体ID
          approverId: approverId, // 审批主体ID
          businessType: businessType
        }
        
        // 调用API添加代理关系
        await sendApproval(relationData)
        
        ElMessage.success('发送邀请成功')
        
        // 刷新用户列表
        await this.loadUserList()
        
        // 关闭对应的弹窗
        if (userType === 'personal') {
          this.invitePersonalDialogVisible = false
        } else {
          this.inviteEnterpriseDialogVisible = false
        }
      } catch (error) {
        console.error(`邀请${userType === 'personal' ? '个人' : '企业'}用户失败:`, error)
      }
    },
    /**
     * 邀请授权代理
     */
    async handleInviteProxy(row) {
      const displayName = this.activeUserType === 'personal' 
        ? (row.userNickName || row.userRealName || '用户')
        : (row.entName || '企业')
      
      try {
        const confirmed = await showEnhancedConfirmDialog(
          `确定要邀请${this.activeUserType === 'personal' ? '个人用户' : '企业用户'}"${displayName}"授权代理吗？`,
          '邀请授权代理',
          '确定',
          '取消',
          { type: 'info' }
        )
        if (!confirmed) return

        // 获取当前企业信息
        const agentEntId = this.$auth.getCurrentMainBodyId()
        
        if (!agentEntId) {
          ElMessage.error('无法获取当前企业信息')
          return
        }
        
        // 构建发送审批申请的数据
        const relationData = {
          applicantId: agentEntId, // 发起企业ID
          approverId: row.clientMainBodyId, // 审批用户/企业统一主体ID
          businessType: BusinessTypeEnum.CHANNEL_INVITE_AGENCY_AUTH.code, // 这里是渠道代理授权邀请
          businessId: row.id // 业务ID
        }
        
        // 调用API发送审批申请
        await sendApproval(relationData)
        
        ElMessage.success('邀请授权代理申请已发送')
        
        // 刷新用户列表
        await this.loadUserList()
      } catch (error) {
        if (error !== 'cancel') {
          console.error('邀请授权代理失败:', error)
        }
      }
    },
    /**
     * 取消用户授权
     */
    async handleCancelAgency(row) {
      const displayName = this.activeUserType === 'personal' 
        ? (row.userNickName || row.userRealName || '用户')
        : (row.entName || '企业')
      
      try {
        const confirmed = await showEnhancedConfirmDialog(
          `确定要取消${this.activeUserType === 'personal' ? '个人用户' : '企业用户'}"${displayName}"的授权代理吗？`,
          '取消授权代理',
          '确定',
          '取消',
          { type: 'warning' }
        )
        if (!confirmed) return

        const response = await cancelCustomerAgency(row.id)
        if (response && response.code === 200) {
          // ElMessage.success('取消授权代理成功')
          await this.loadUserList()
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('取消授权代理失败:', error)
        }
      }
    },
    /**
     * 编辑用户
     */
    handleEdit(row) {
      const displayName = this.activeUserType === 'personal' 
        ? (row.userNickName || row.userRealName || '用户')
        : (row.entName || '企业')
      ElMessage.info(`编辑${this.activeUserType === 'personal' ? '用户' : '企业'}: ${displayName}`)
      // TODO: 打开编辑用户对话框
    },
    /**
     * 删除用户
     */
    async handleDelete(row) {
      const displayName = this.activeUserType === 'personal' 
        ? (row.userNickName || row.userRealName || '用户')
        : (row.entName || '企业')
      
      try {
        const confirmed = await showEnhancedConfirmDialog(
          `确定要移除${this.activeUserType === 'personal' ? '个人用户' : '企业用户'}"${displayName}"吗？`,
          '提示',
          '确定',
          '取消',
          { type: 'warning' }
        )
        if (!confirmed) return

        const response = await removeClient(row.id)
        if (response && response.code === 200) {
          ElMessage.success('移除成功')
          this.loadUserList()
        } else {
          ElMessage.error(response.msg || '移除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('移除失败:', error)
        }
      }
    },
    /**
     * 获取认证状态文本
     */
    getVerifiedStatusText(isVerified) {
      const statusMap = {
        '0': '未认证',
        '1': '认证中',
        '2': '已认证',
        '3': '未通过'
      }
      return statusMap[String(isVerified)] || '未知'
    },
    /**
     * 获取认证状态标签类型
     */
    getVerifiedStatusType(isVerified) {
      const status = String(isVerified)
      if (status === '2') {
        return 'success'
      } else if (status === '1') {
        return 'warning'
      } else if (status === '3') {
        return 'danger'
      } else {
        return 'info'
      }
    },
    /**
     * 获取关系状态文本
     */
    getRelationStatusText(authStatus) {
      const statusMap = {
        '0': '未授权',
        '1': '已授权'
      }
      return statusMap[String(authStatus)] || '未知'
    },
    /**
     * 获取授权代理状态标签类型
     */
    getRelationStatusType(authStatus) {
      const statusValue = String(authStatus)
      if (statusValue === '1') {
        return 'success'
      } else if (statusValue === '0') {
        return 'info'
      } else {
        return 'info'
      }
    },
    /**
     * 分页大小改变
     */
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.pagination.pageNum = 1
      this.loadUserList()
    },
    /**
     * 页码改变
     */
    handlePageChange(val) {
      this.pagination.pageNum = val
      this.loadUserList()
    }
  }
}
</script>

<style lang="scss" scoped>
.user-management {
  min-height: 100%;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .user-management {
    .user-type-segment-wrap {
      width: 100%;
    }

    :deep(.user-type-segment) {
      display: flex;
      width: 100%;
      max-width: 100%;
      flex-wrap: nowrap;
      box-sizing: border-box;

      .segment-item {
        flex: 1 1 0;
        width: 0;
        min-width: 0;
        padding: 0 12px;
        text-align: center;
      }
    }

    :deep(.search-field.el-form-item) {
      width: 100%;
      min-width: 0;
      flex-direction: column;
      align-items: stretch;
    }

    :deep(.search-field .el-form-item__label) {
      width: 100% !important;
      padding-right: 0;
      padding-bottom: 6px;
      line-height: 1.4;
    }

    :deep(.search-field .el-form-item__content) {
      width: 100%;
    }

    :deep(.search-field .search-input),
    :deep(.search-field .search-select),
    :deep(.search-field .el-select) {
      width: 100%;
      min-width: 0;
    }

    .search-actions {
      width: 100%;
      margin-left: 0;

      .el-button {
        flex: 1;
        min-width: 0;
      }
    }

    .action-bar {
      .el-button {
        width: 100%;
      }
    }

    .table-wrap {
      width: 100%;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }

    .user-table {
      min-width: 960px;
      height: 420px !important;
    }

    .pagination-section {
      justify-content: center;

      :deep(.el-pagination) {
        width: 100%;
        flex-wrap: wrap;
        justify-content: center;
        row-gap: 8px;
      }

      :deep(.el-pagination__sizes),
      :deep(.el-pagination__jump) {
        display: none;
      }
    }
  }
}

@media (max-width: 480px) {
  .user-management {
    :deep(.user-type-segment .segment-item) {
      height: 34px;
      line-height: 34px;
      font-size: 13px;
      padding: 0 12px;
    }

    .user-table {
      min-width: 720px;
      height: 360px !important;

      :deep(.el-button) {
        padding: 4px 8px;
        font-size: 12px;
      }
    }

    .pagination-section {
      :deep(.el-pagination__total) {
        display: none;
      }
    }
  }
}
</style>

